export default __webpack_public_path__ + "static/media/pic5.b1af4519.jpg";